
import React from "react";
import { ScriptureTools } from "./features/ScriptureTools";

const FeaturesSection = () => {
  return <section className="bg-white py-16">
      <div className="container mx-auto px-6">
        <ScriptureTools />
      </div>
    </section>;
};

export default FeaturesSection;
